import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const surveyPlanMap = new Map();

surveyPlanMap.set(KnowEdmTableData.Md, {
  key: KnowEdmTableData.Md,
  label: 'MD',
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyPlanMap.set(KnowEdmTableData.Inclination, {
  key: KnowEdmTableData.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'INC',
});

surveyPlanMap.set(KnowEdmTableData.Azimuth, {
  key: KnowEdmTableData.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'AZI',
});

surveyPlanMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'TVD',
});

surveyPlanMap.set(KnowEdmTableData.Ew, {
  key: KnowEdmTableData.Ew,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'EW',
});

surveyPlanMap.set(KnowEdmTableData.Ns, {
  key: KnowEdmTableData.Ns,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NS',
});

surveyPlanMap.set(KnowEdmTableData.Vsec, {
  key: KnowEdmTableData.Vsec,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'V.sec',
});

surveyPlanMap.set(KnowEdmTableData.Dls, {
  key: KnowEdmTableData.Dls,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
  label: 'DLS',
});

surveyPlanMap.set(KnowEdmTableData.BuildRate, {
  key: KnowEdmTableData.BuildRate,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
  label: 'Build',
});

surveyPlanMap.set(KnowEdmTableData.TurnRate, {
  key: KnowEdmTableData.TurnRate,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
  label: 'TurnRate',
});

surveyPlanMap.set(KnowEdmTableData.Tfo, {
  key: KnowEdmTableData.Tfo,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'TFO',
});

export {
  surveyPlanMap,
};